export enum OAuthProvider {
  Google = 'google',
  Microsoft = 'microsoft',
  GitHub = 'github',
  Email = 'email',
}
